<template>
    <label :for="id" class="c-label" :class="customClass !== 'undefined' && customClass ? customClass : ''">
        <slot></slot>
    </label>
</template>

<script>
    export default {
        props: ['custom-class', 'id']
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/form/Label.vue